<template>
  <div class="report_detail_container">
    <!-- 详情 -->
    <detail :detail="dmInfo" v-if="!!dmInfo"></detail>
    <!-- 评论 -->
    <div ref="comment">
      <comment :show="isShowComment" :params="commentParams" @closeComment="closeComments" @replyForm="showCommentReplayForm" v-if="!!dmInfo"></comment>
    </div>
    <!-- 底部操作 -->
    <operate :params="detailParams" :id="dmInfo.id" :isCollect="dmInfo.isCollect" :deviceId="deviceId" v-if="!!dmInfo" @showCommentForm="showCommentForm" @showComments="showComments"></operate>
    <!-- 发布评论 -->
    <submit-comment v-if="!!dmInfo" :show="isShowCommentForm" :id="dmInfo.id" :type="detailParams.contentType" :parentId="commentParentId" :title="dmInfo.title" @showCommentForm="showCommentForm"></submit-comment>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getRandomStr32, clickPlayCount } from "@/utils";
import reportApi from "@/api/apis/report.js";
import commApi from "@/api/apis/common.js";
import detail from "./components/Detail"; //详情
import comment from "./components/Comment"; // 评论
import operate from "./components/Operate"; // 底部
import submitComment from "./components/SubmitComment"; //发表评论
export default {
  name: "ReportDetail",
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  data() {
    return {
      /* 是否显示评论表单 */
      isShowCommentForm: false,
      /* 是否显示所有评论的弹层 */
      isShowComment: false,
      commentParentId: "0",
      /* 设备Id */
      deviceId: null,
      /* 获取详情所需的参数 */
      detailParams: {
        contentType: null,
        contentId: null,
        fromFlag: null,
        cId: null,
      },
      /* 获取评论列表的参数 */
      commentParams: {
        contentId: null,
        type: null,
      },
      dmInfo: null,
    };
  },
  components: {
    detail,
    comment,
    operate,
    submitComment,
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      let url = location.href.replace("/report_detail?","/index_share?");

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: url
      }).then((res) => {
        let subTitle = "";
        if (!!_this.dmInfo.description && _this.dmInfo.description.length > 0) {
          subTitle = _this.dmInfo.description;
        } else if (!!_this.dmInfo.introduction && _this.dmInfo.introduction.length > 0) {
          subTitle = _this.dmInfo.introduction;
        } else {
          subTitle = _this.dmInfo.title;
        }
        
        var shareImgurl = "";
        if (_this.dmInfo.isExistStream) {
          shareImgurl = _this.dmInfo.streamInfo.samplePicUrl;
        }else if(!!_this.dmInfo.pictureUrlList && _this.dmInfo.pictureUrlList.length>0){
          shareImgurl = _this.dmInfo.pictureUrlList[0];
        }
        _this.$WeiXin.shareWeiXin(res, "报料", subTitle, url, shareImgurl);
      }).catch((err) => {

      })
    },
    /* 获取报料详情 */
    getReportDetailById() {
      var _this = this;

      reportApi
        .getReportDetailById({ id: _this.detailParams.contentId })
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.title;
            _this.dmInfo = res.data;
            _this.wechatShare(); // 微信二次分享
            _this.commentParams.contentId = _this.dmInfo.id;
            _this.statistics(); // 统计
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.dmInfo.contentCreationTime, // 创建时间
        contentId: this.dmInfo.id, // 稿件Id
        contentTitle: this.dmInfo.title,
        contentType: 16,
      };
      if (!!this.userInfo) {
        tj_params = Object.assign(tj_params, {
          memberId: this.userInfo.id, //会员id
          nickName: this.userInfo.nickName, //用户名称
        });
      }
      if (this.detailParams.fromFlag == 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.dmInfo.channelId, // 栏目id
          channelName: this.dmInfo.channelName, // 栏目名称
        });
      }
      clickPlayCount(tj_params);
    },
    /* 显示或隐藏评论表单 */
    showCommentForm(data) {
      this.isShowCommentForm = data;
      this.commentParentId = "0";
    },
    /* 评论回复,显示评论表单 */
    showCommentReplayForm(data) {
      this.isShowCommentForm = true;
      this.commentParentId = data;
    },
    /* 显示所有评论 */
    showComments() {
      this.isShowComment = true;
    },
    /* 关闭所有评论 */
    closeComments() {
      this.isShowComment = false;
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.detailParams.contentType = Number(query.contentType) || 16;
      this.detailParams.contentId = Number(query.contentId);
      this.detailParams.fromFlag = query.fromFlag || 0;
      if (!!this.userInfo) {
        this.detailParams.memberId = this.userInfo.id;
      }
      this.commentParams.type = this.detailParams.contentType || 16;
      this.getReportDetailById();
    }
    if (!this.userInfo) {
      this.deviceId = getRandomStr32();
    }
  },
};
</script>
<style scoped lang="scss">
.report_detail_container {
  width: 100%;
  height: 100%;
  padding: 10px 15px;
  overflow-x: hidden;
  overflow-y: auto;
  .comment_box {
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>